import { HighlightSearchPipe } from './highlight-search.pipe';
import { FaqCategory, FaqCategoryItem, FaqMatchedItem } from './../faq.model';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

@Component({
  selector: 'jhi-faq-search',
  templateUrl: './faq-search.component.html',
  styleUrls: ['./faq-search.component.scss']
})
export class FaqSearchComponent implements OnInit, OnChanges {

    @Input()
    categories: Array<FaqCategory>;

    searchText: string;
    items: Array<FaqCategoryItem>;
    matchedItems: Array<FaqMatchedItem>;

    constructor(
        private highlightSearchPipe: HighlightSearchPipe,
        private titleService: Title) { }

    ngOnInit() {
    }

    ngOnChanges(_changes: SimpleChanges) {
        if (this.categories) {
            this.items = [];
            this.categories.forEach(category => {
                // because we need escape html tag after
                let copyItems = jQuery.extend(true, [], category.items);
                this.items = this.items.concat(copyItems);
            });

        }
    }

    resetSearch(): void {
        this.searchText = null;
    }

    getHighLightItems(): void {
        this.matchedItems = this.highlightSearchPipe.transform(this.items, this.searchText);
        this.titleService.setTitle(
            `Aide : ${this.matchedItems.length} résultats de recherche pour le terme "${this.searchText}"${PAGE_TITLE_SUFFIX}`
            )
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq-search/faq-search.component.ts